import React, {useState} from 'react'
import {Button, Col, Divider, Form, Input, Modal, Row, Select} from "antd";
import {createCustomerBulk} from "../../services/serviceCustomer";
import config from "../../config";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";
import CustomerBulkRelevant from "./CustomerBulkRelevant";
import CustomerBulkAddress from "./CustomerBulkAddress";
import Customer from "./Customer";


const formLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
}

const { TextArea } = Input
const { Option } = Select

const CustomerCreate = ({show, modalCloser, updater}) => {
    const [form] = Form.useForm()
    const [loadings, setLoadings] = useState([])
    const [addresses, setAddresses] = useState([])
    const [relevants, setRelevants] = useState([])

    const handleSubmit = (list) => {
        enterLoadingState(setLoadings)
        let requestObj = {
            customer: {
                name: list.customerName,
                description: list.customerDescription,
                email: list.customerEmail,
                website: list.customerWebSite,
                fax: list.customerFax,
                sector: list.customerSector,
                internalPhone: list.customerInternalPhone,
                mobilePhone: list.customerMobilePhone,
                taxNo: list.customerTaxNo,
                taxOffice: list.customerTaxOffice,
                cargoCompany: list.cargoCompany
            },
            customerAddress: addresses,
            relevantPerson: relevants
        }
        createCustomerBulk(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                modalCloser()
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Modal
                open={show}
                closable={false}
                style={{minWidth: '75%'}}
                title={'Yeni Müşteri Ekle'}
                footer={[
                    <Button type={'primary'}
                            key={'SubmitButton'}
                            loading={loadings[0]}
                            onClick={() => form.submit()}
                    >Kaydet</Button>,
                    <Button  key={'CancelButton'} onClick={() => modalCloser()} >Kapat</Button>
                ]}
            >
                <Row gutter={32}>
                    <Col span={10}>
                        <Form
                            form={form}
                            {...formLayout}
                            onFinish={() => handleSubmit(form.getFieldsValue())}
                        >

                            <Form.Item
                                label={'Müşteri Adı'}
                                name={'customerName'}
                                rules={[
                                    {required:true, message:'İsim Alanı Boş Bırakılamaz'},
                                    {min:5, max:300, message:'İsim Alanı En Az 5, En Fazla 300 Karakter Olmalı'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Sektör'}
                                name={'customerSector'}
                                rules={[
                                    {max:50, message: 'Sektör Alanı En Fazla 50 Karakter Olmalı'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Vergi No'}
                                name={'customerTaxNo'}
                                rules={[
                                    {min:10, max:11, message: 'Vergi No Alanı En Az 10 En Fazla 11 Karakter Olmalı'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Vergi Dairesi'}
                                name={'customerTaxOffice'}
                                rules={[
                                    {max:50, message: 'Vergi Dairesi En Fazla 50 Karakter Olmalı'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Web Sitesi'}
                                name={'customerWebSite'}
                                rules={[
                                    {max: 100, message: 'Web Sitesi En Fazla 100 Karakter Olmalı'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Cep Telefonu'}
                                name={'customerMobilePhone'}
                                rules={[
                                    {max: 20, message: 'Cep Telefonu En Fazla 20 Karakter Olmalı'},
                                    {pattern: /^\d*$/, message: 'Cep Telefonu Sadece Rakam İçermelidir'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Sabit Hat'}
                                name={'customerInternalPhone'}
                                rules={[
                                    {max: 20, message: 'Sabit Hat En Fazla 20 Karakter Olmalı'},
                                    {pattern: /^\d*$/, message: 'Sabit Hat Sadece Rakam İçermelidir'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Email'}
                                name={'customerEmail'}
                                rules={[
                                    {type: 'email', message:'Doğru bir E-mail Formatı Girilmelidir (örnek@örnek.com)'},
                                    {max: 100, message: 'E-mail Alanı En Fazla 100 Karakterden Oluşmalıdır'}
                                ]}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Fax'}
                                name={'customerFax'}
                            >
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label={'Kargo Şirketi'}
                                name={'cargoCompany'}
                            >
                                <Select>
                                    {
                                        config.cargoOptions.map((item, index) => <Option key={index} value={item}>{item}</Option>)
                                    }
                                </Select>
                            </Form.Item>
                            <Form.Item
                                label={'Not'}
                                name={'customerDescription'}
                                rules={[
                                    {max: 500, message: 'Not Alanı En Fazla 500 Karakterden Oluşmalıdır'}
                                ]}
                            >
                                <TextArea />
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col>
                        <Divider type={'vertical'} style={{height: '100%'}}/>
                    </Col>
                    <Col span={12}>
                        <CustomerBulkAddress updater={setAddresses} />
                        <CustomerBulkRelevant updater={setRelevants}/>
                    </Col>
                </Row>
            </Modal>
        </React.Fragment>
    )
}
export default CustomerCreate